import { Flag02Icon } from "@hugeicons-pro/core-solid-rounded";
import { HugeiconsIcon } from "@hugeicons/react";
import { Badge, BadgeSize, BadgeVariant } from "shared/components";
import { cx } from "shared/utils";
import { followUpSecondaryLabels } from "./labels";
import type { CallFollowUp } from "./types";

export const FollowUpFlagIcon = ({
  size = 12,
  className
}: {
  size?: number;
  className?: string;
}) => (
  <HugeiconsIcon
    icon={Flag02Icon}
    size={size}
    className={cx("shrink-0 text-danger-500", className)}
    aria-hidden
  />
);

export const FollowUpSecondaryTags = ({
  followUp
}: {
  followUp: Pick<CallFollowUp, "request_types">;
}) => (
  <>
    {followUpSecondaryLabels(followUp).map((label) => (
      <Badge
        key={label}
        variant={BadgeVariant.BASE}
        size={BadgeSize.SM}
        className="shrink-0 items-center"
      >
        {label}
      </Badge>
    ))}
  </>
);

// Same shape as the Fraud indicators pill on the Leads table.
export const FollowUpPill = ({ label }: { label: string }) => (
  <span className="inline-flex max-w-full items-center gap-1.5 rounded-full bg-danger-50 px-2.5 py-1 text-xs font-medium text-danger-500 whitespace-nowrap">
    <FollowUpFlagIcon />
    <span className="truncate">{label}</span>
  </span>
);
